import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ReadMoreText extends Component {
  constructor() {
    super()
    this.state = {
      isTextHidden: true
    }
  }

  static propTypes = {
    children: PropTypes.component,
    isCompactOnly: PropTypes.bool,
    compact: PropTypes.bool
  }

  toggleHidden = () => {
    this.setState({ isTextHidden: !this.state.isTextHidden })
  }

  symbolStyle = {
    fontSize: '150%',
    fontWeight: 200,
    position: 'relative',
    top: '3px'
  }

  render() {
    const { isTextHidden } = this.state
    const { children, isCompactOnly, compact } = this.props
    if (isCompactOnly) {
      if (!compact) {
        return <div>{children}</div>
      }
    }
    if (isTextHidden) {
      return (
        <div onClick={this.toggleHidden}>
          <div style={{ color: '#0082C7', marginTop: '2em' }}>
            <span style={{ textDecoration: 'underline ' }}>Read More</span>{' '}
            <span style={this.symbolStyle}>+</span>
          </div>
        </div>
      )
    }
    return (
      <div>
        {children}
        <div onClick={this.toggleHidden}>
          <div style={{ color: '#0082C7', marginTop: '2em' }}>
            <span style={{ textDecoration: 'underline ' }}>Show Less</span>{' '}
            <span style={this.symbolStyle}>–</span>
          </div>
        </div>
      </div>
    )
  }
}

export default ReadMoreText



// WEBPACK FOOTER //
// ./src/containers/read-more-text/index.jsx